module.exports = __webpack_public_path__ + "img/logo-white.59f47f7.png";